import * as React from "react";
import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input"> & {
  hideBorder?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hideBorder = false, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        style={{
          borderColor: props?.["fieldborderColor"],
        }}
        className={cn(
          "flex h-10 w-full rounded-md bg-background px-3 py-2 text-base shadow ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",

          !hideBorder && "border border-input",

          // Date input specific styles
              type === "date" &&
            "[&::-webkit-calendar-picker-indicator]:cursor-pointer",

          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
